import lottie from "../lottie";
import animationData from "./animation-data";

var params = {
   container: document.getElementById("hero-1"),
   renderer: 'svg',
   loop: true,
   autoplay: true,
   animationData: animationData
};

var anim;

anim = lottie.loadAnimation(params);

/****************************************************
   Animate the "B12" lottie loop
****************************************************/

function translateChar(currentNode) {
   let previousTimestamp;
   let previousNode;

   const update = (timestamp) => {
      if (previousTimestamp !== timestamp) {
         // Make only the front node red
         if (previousNode) {
            previousNode.style.setProperty("fill", "rgb(249,244,234)", "important");
         }
         currentNode.style.setProperty("fill", "rgb(227,29,34)", "important");

         // Show the next node
         currentNode.style.setProperty("display", "block", "important");
      }

      if (currentNode.nextElementSibling) {
         previousTimestamp = timestamp;
         previousNode = currentNode;
         currentNode = currentNode.nextElementSibling;
         window.requestAnimationFrame(update);
      }
   }

   update();
}

const chars = Array.from(document.querySelectorAll("#hero-1 svg > g > g"));
chars.reverse().forEach((char, i) => {
   // Get the first of the many clones
   const firstClone = char.querySelector("g > g");

   // Start animation with delay
   setTimeout(() => {
      translateChar(firstClone);
   }, i * 70);
});

